import { createContext, useCallback, useContext, useState } from "react";

const BookingContext = createContext({ openBooking: () => {}, closeBooking: () => {} });

export const useBooking = () => useContext(BookingContext);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [service, setService] = useState("");

  const openBooking = useCallback((preset = "") => {
    setService(preset);
    setOpen(true);
  }, []);
  const closeBooking = useCallback(() => setOpen(false), []);

  return (
    <BookingContext.Provider value={{ open, service, setOpen, openBooking, closeBooking }}>
      {children}
    </BookingContext.Provider>
  );
}
